import React from "react";
import "../../../style/components/dialogs/enable-paid-features/multi-tenancy.module.css";

export interface PricingSection {
    header?: string;
    pricingDetails: PricingDetail[];
}

export interface PricingDetail {
    highlight: { text: string; color: string };
    description: React.ReactNode;
}

export interface MultiTenancyConfig {
    pricingSections: PricingSection[];
    link: { text: string; url: string };
}

const MultiTenancyPricingCard = ({ config }: { config: MultiTenancyConfig }) => {
    return (
        <div className="multi-tenancy-pricing-card">
            {config.pricingSections.map((section, index) => (
                <div key={index} className="multi-tenancy-pricing-section">
                    {section.header && <div className="multi-tenancy-pricing-header">{section.header}</div>}

                    {section.pricingDetails.map((item, index) => (
                        <div key={index} className="multi-tenancy-pricing-item">
                            <span className={`multi-tenancy-pricing-highlight ${item.highlight.color}`}>
                                {item.highlight.text}
                            </span>
                            <span className="multi-tenancy-pricing-description">{item.description}</span>
                        </div>
                    ))}
                </div>
            ))}

            <div className="multi-tenancy-pricing-divider"></div>

            <div className="multi-tenancy-pricing-link">
                <a target="_blank" href={config.link.url}>
                    {config.link.text}
                </a>
                <svg width="3" height="4" viewBox="0 0 3 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.71653 1.67267C2.87924 1.86056 2.87924 2.13944 2.71653 2.32733L1.62797 3.58429C1.3249 3.93424 0.75 3.71991 0.75 3.25696L0.75 0.743037C0.75 0.280094 1.3249 0.0657583 1.62796 0.41571L2.71653 1.67267Z"
                        fill="#007AFF"
                    />
                </svg>
            </div>
        </div>
    );
};

export default MultiTenancyPricingCard;
